import React, {useState} from "react";
import {Controller, useFormContext, useFormState} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
import {FormGroup, FormControl, Label, ErrorText, InputGroup} from "../styles";
import Button from "components/Button";
import eyeSlashIcon from "assets/images/eye_slash.svg";
import eyeIcon from "assets/images/eye.svg";

export default function FormInput({fieldName, type = "input", label}){
  const {control} = useFormContext();
  const { errors } = useFormState();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Controller name={fieldName} control={control} render={({field, fieldState}) => (
      <FormGroup>
        <Label>{label}</Label>
        {type === "password" ? (
            <InputGroup>
              <FormControl type={showPassword? "text": "password"} value={field.value} onChange={field.onChange} />
              <Button variant="icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (<img src={eyeSlashIcon} alt="hidePassword" />) : (
                  <img src={eyeIcon} alt="showPassword" />
                )}
              </Button>
            </InputGroup>
          ) : (
            <FormControl type={type} value={field.value} onChange={(e) => {
              field.onChange(type === "number" ? parseInt(e.target.value, 10) : e)
            }} />
          )
        }
        <ErrorMessage name={fieldName} errors={errors} render={({message}) => <ErrorText>*{message}</ErrorText>} />
      </FormGroup>
    )} />
  )
}
